import React from "react";
import { Box } from "@mui/material";
import Field from "../shared/Field";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormFeatures = ({ draft, setDraft }) => (
  <Box>
    <Box display="grid" gridTemplateColumns="1fr 2fr" gap={2}>
      <ImageUploadField
        label="Icon Image"
        value={draft.icon}
        onChange={(v) => setDraft((p) => ({ ...p, icon: v }))}
      />
      <Field
        label="Title"
        value={draft.title}
        onChange={(v) => setDraft((p) => ({ ...p, title: v }))}
        placeholder="React Frontend Development"
      />
    </Box>
    <Field
      label="Description"
      value={draft.description}
      onChange={(v) => setDraft((p) => ({ ...p, description: v }))}
      multiline
      placeholder="Build dynamic, responsive UIs..."
    />
    <Field
      label="Tech Tags (comma separated)"
      value={draft.tags}
      onChange={(v) => setDraft((p) => ({ ...p, tags: v }))}
      placeholder="React, TypeScript, Redux Toolkit, Vite"
    />
  </Box>
);

export default FormFeatures;
